import React from 'react'
import { Redirect, useLocation, useParams } from 'react-router-dom'

const CompareReportLegacyRedirect = ({ routePrefix }) => {
  const { clientId } = useParams()
  const { search } = useLocation()
  const query = new URLSearchParams(search)

  if (!query.get('clientId') && clientId) {
    query.set('clientId', clientId)
  }

  return (
    <Redirect to={`/${routePrefix}/comparison-report?${query.toString()}`} />
  )
}

export const ProsperityCompareReportLegacyRedirect = () => (
  <CompareReportLegacyRedirect routePrefix='prosperity' />
)

export const SurveyCompareReportLegacyRedirect = () => (
  <CompareReportLegacyRedirect routePrefix='survey' />
)
